import Vue from 'vue'
import 'tsa-ui/lib/theme-chalk/tsa-icon.css'
import {
    Button,
    Select,
    Option,
    Input,
    Radio,
    RadioGroup,
    RadioButton,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Loading,
    Message,
    MessageBox,
    Tooltip,
    DatePicker,
    Dialog,
    Form,
    FormItem,
    ConditionSelect,
    CustomizeMessageBox,
    CustomizeToast,
    SlideMenu,
    CustomizeTable,
    TableColumn,
    Table,
    Popover,
    Row,
    Col,
    Scrollbar,
    Drawer,
    Carousel,
    CarouselItem,
    Progress,
    InputNumber,
} from "tsa-ui";

Vue.use(Tooltip)
    .use(DatePicker)
    .use(Dialog)
    .use(Form)
    .use(FormItem)
    .use(Loading)
    .use(Button)
    .use(Select)
    .use(Option)
    .use(Input)
    .use(Radio)
    .use(RadioGroup)
    .use(RadioButton)
    .use(Checkbox)
    .use(CheckboxButton)
    .use(CheckboxGroup)
    .use(ConditionSelect)
    .use(CustomizeMessageBox)
    .use(CustomizeToast)
    .use(SlideMenu)
    .use(CustomizeTable)
    .use(TableColumn)
    .use(Table)
    .use(Popover)
    .use(Row)
    .use(Col)
    .use(Scrollbar)
    .use(Drawer)
    .use(Carousel)
    .use(CarouselItem)
    .use(Progress)
    .use(InputNumber)

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;